import { render, staticRenderFns } from "./company-trend.vue?vue&type=template&id=6e8d2b90&"
import script from "./company-trend.vue?vue&type=script&lang=js&"
export * from "./company-trend.vue?vue&type=script&lang=js&"
import style0 from "./company-trend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports